<template>
  <div
    ref="detailPage"
    class="detail-page"
  >
    <header-back
      :title="code"
      @back="onClickBack"
    >
      <template slot="center">
        <span class="code">{{ code }}</span>
        <span
          v-if="permissionInfo.is_synced_xiaoman && code === detailData.info.code"
          class="assoc-xiaoman"
        >小满</span>
      </template>
      <template
        v-if="permissionInfo && tab !== 'changeHistory' && tab !== 'followupReply' && tab !== 'commentReply' && tab !== 'addFollowup' && tab !=='archive'"
        slot="right"
      >
        <div
          v-if="permissionInfo.is_show_del || permissionInfo.is_show_apply|| permissionInfo.is_show_historys"
          class="filter-set fs-blue"
          @click="handleAction"
        >
          <i
            class="iconfont iconicon-test20"
          />
        </div>
      </template>
    </header-back>
    <a-alert
      v-if="(tab ==='baseDetail' || !tab) && recycleLogTips"
      :message="recycleLogTips"
      type="info"
      show-icon
      class="common-alert-info"
    >
      <i
        slot="icon"
        class="iconfont iconicon-test1"
      />
    </a-alert>
    <div
      v-if="!loading && Object.keys(detailData).length > 0"
      class="content"
    >
      <!-- 待审核和已拒审的询盘详情 -->
      <tab-slide-form
        v-if="!showPassTab"
        :type="type"
        :form-data="formData"
        :reject-data="detailData.audit_info || {}"
      />
      <!-- 审核通过的询盘详情 -->
      <tab-slide
        v-else
        :form-data="formData"
        :detail-data="detailData"
      />
    </div>
    <div
      v-else-if="!loading && Object.keys(detailData).length === 0"
      class="blank"
    >
      <img
        src="@/assets/images/blank.png"
        :alt="altTip"
      >
      <div class="text">
        {{ $t('message["343"]') }}
      </div>
    </div>
    <cube-loading
      v-else
      :size="24"
    />

    <!-- 申请重新分配弹窗 -->
    <apply-modal
      :visible.sync="showApplyModal"
      :inquiry-id="inquiryId"
    />
    <!-- 图片预览 -->
    <gallery />
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import eventBus from '@/lib/eventBus'
import HeaderBack from '@/components/mobile/HeaderBack.vue'
import TabSlide from './TabSlide'
import TabSlideForm from './TabSlideForm'
import ApplyModal from './modal/ApplyModal'
import Gallery from '@/components/pc/Gallery'
import { setReplyPositionQuery } from '@/lib/before-router'

const FROM_SOPURCE = 'notice'

export default {
  components: {
    HeaderBack,
    TabSlide,
    TabSlideForm,
    ApplyModal,
    Gallery
  },
  data () {
    return {
      showApplyModal: false,
      // titleName: '',
      scrollTop: 0,
      confirmLoading: false,
      showArchiveModal: true
    }
  },
  computed: {
    ...mapState(['menuDatas', 'baseinfo']),
    ...mapState('inquery/detailData', [
      'loading',
      'detailData'
    ]),
    ...mapState('inquery/relateData', ['recycleLogTips']),
    ...mapGetters('inquery/detailData', [
      'formData',
      'permissionInfo'
    ]),
    inquiryId () {
      return this.$route.params.inquiryId
    },
    from () { // all, my, audit, checkrepeat
      return this.$route.query.from
    },
    type () {
      return this.$route.query.type
    },
    tab () {
      return this.$route.query.tab
    },
    code () {
      if (this.tab === 'changeHistory') {
        return this.$t('message["48"]')
      } else if (this.tab === 'followupReply') {
        return this.$t('message["441"]')
      } else if (this.tab === 'commentReply') {
        return this.$t('message["716"]')
      } else if (this.tab === 'addFollowup') {
        return this.$t('message["1348"]')
      } else if (this.tab === 'archive') {
        return this.$t('message["1776"]')
      } else {
        return (this.detailData && this.detailData.info && this.detailData.info.code) || ''
      }
    },
    checkrepeatfieldkey () {
      return this.$route.query.checkrepeatfieldkey
    },
    auditStatus () {
      const { info = {} } = this.detailData
      const { audit_status: auditStatus } = info
      return auditStatus
    },
    showPassTab () {
      let flag = false
      if (this.from === 'audit') {
        flag = false
      } else {
        if (this.auditStatus === 0 || this.auditStatus === -1) {
          flag = false
        } else if (this.auditStatus === 1) {
          flag = true
        }
      }
      return flag
    },
    altTip () {
      return this.$t('message["1553"]')
    }
  },

  async created () {
    this.permissionMenu()
    await this.getDetail()
    eventBus.$on('fetchInquiryDetail', this.getDetail)

    this.redirectRouter()

    this.$nextTick(() => {
      let $detailPageParent = this.$refs.detailPage && this.$refs.detailPage.offsetParent
      $detailPageParent.addEventListener('scroll', () => {
        if (this.tab === 'baseDetail') {
          this.scrollTop = $detailPageParent.scrollTop || 0
          // console.log(this.scrollTop)
        }
      })
    })
  },
  destroyed () {
    eventBus.$off('fetchInquiryDetail')
    this.UPDATA_DETAIL({})
  },
  methods: {
    ...mapActions(['permissionMenu']),
    ...mapMutations('inquery/detailData', ['UPDATA_DETAIL', 'SET_LOADING']),
    ...mapActions('inquery/detailData', [
      'fetchDetail',
      'deleteDetail',
      'getArchiveTypes',
      'inquirySyncxiaoman'
    ]),
    onClickBack () {
      // console.log(this.from, this.tab)
      if (this.from === FROM_SOPURCE && (this.tab === 'baseDetail' || !this.tab)) {
        this.$router.push({ name: 'recordNotice' })
        return
      }
      if (this.from === 'webhook') {
        this.$router.push({
          name: 'ProjectIndex'
        })
        return
      }
      if (this.tab === 'changeHistory' || this.tab === 'followupReply' || this.tab === 'commentReply' || this.tab === 'addFollowup' || this.tab === 'archive') {
        let oldQuery = this.$route.query
        delete oldQuery.followupid
        delete oldQuery.commentid
        this.$router.push({
          query: {
            ...oldQuery,
            tab: 'baseDetail'
          }
        })

        setTimeout(() => {
          if (this.$refs.detailPage && this.$refs.detailPage.offsetParent) {
            this.$refs.detailPage.offsetParent.scrollTo({
              top: this.scrollTop || 0,
              behavior: 'smooth'
            })
          }
        }, 0)

        return
      }
      let name = ''
      if (this.type || this.from) {
        const query = JSON.parse(JSON.stringify(this.$route.query))
        if (this.from === 'audit') {
          name = 'InqueryAudit'
        } else if (this.from === 'checkrepeat') {
          name = 'InqueryRepeat'
        } else {
          name = 'InqueryList'
          delete query.tab
        }
        this.$router.push({
          name,
          query: {
            ...query,
            type: this.type,
            from: this.from
          }
        })
      } else {
        name = 'ProjectIndex'
        this.$router.push({
          name
        })
      }
    },
    async getDetail () {
      if (!this.inquiryId) return
      const chain = await this.fetchDetail()
      chain
        .params({
          inquiryid: this.inquiryId,
          scope: this.from,
          checkrepeatfieldkey: this.checkrepeatfieldkey
        })
        .onNetSuccess((res = {}) => {
          this.setDocumentTitle(res)
        })
        .onFail((e, error) => {
          this.SET_LOADING(false)
        })
        .fetch()
    },
    async setDocumentTitle (res) {
      let projectname, comname
      let { baseinfo = {} } = res.data || {}
      comname = baseinfo.comname
      projectname = baseinfo.projectname

      const chain = await this.permissionMenu()
      chain.onSuccess(payload => {
        const { permissionMenuList = {} } = this.menuDatas
        let parent = {}
        if (this.from === 'my') {
          parent = permissionMenuList['inquiry-mine']
        } else if (this.from === 'all') {
          parent = permissionMenuList['inquiry-all']
        } else if (this.from === 'audit') {
          parent = permissionMenuList['inquiry-audit']
        }
        let { child = {} } = parent || {}
        let { name = '' } = (child && child[this.type]) || {}

        if (this.from === 'notice') {
          name = '通知'
        } else if (this.from === 'webhook') {
          name = '推送记录'
        }

        document.title = name + '-' + projectname + '-' + comname
      })
    },
    redirectRouter () {
      const noticeQuery = setReplyPositionQuery()

      if (noticeQuery) {
        this.$router.push({ ...this.$route, query: noticeQuery })
      } else {
        this.$router.push({ ...this.$route })
      }
    },
    handleApply () {
      this.showApplyModal = true
    },
    handleDelete () {
      this.$createDialog({
        type: 'confirm',
        icon: 'cubeic-alert',
        title: this.$t('message["493"]'),
        content: this.$t('message["969"]') + '？',
        confirmBtn: {
          text: this.$t('message["915"]'),
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: this.$t('message["896"]'),
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          this.confirmDelete()
        },
        onCancel: () => {
          /* this.$createToast({
            type: 'warn',
            time: 1000,
            txt: '点击取消按钮'
          }).show() */
        }
      }).show()
    },
    async confirmDelete () {
      const chain = await this.deleteDetail()
      chain
        .onSuccess((raw, res) => {
          if (!res.error) {
            let name = ''
            if (this.from === 'audit') {
              name = 'InqueryAudit'
            } else if (this.from === 'checkrepeat') {
              name = 'InqueryRepeat'
            } else {
              name = 'InqueryList'
            }
            if (this.from && this.type) {
              this.$router.push({
                name,
                query: {
                  type: this.type,
                  from: this.from
                }
              })
            } else if (this.from === FROM_SOPURCE) {
              this.$router.push({ name: 'recordNotice' })
            } else if (this.form === 'webhook') {
              this.$router.push({
                name: 'configSendRecord',
                params: {
                  hookid: this.$route.query.hookid
                }
              })
            } else if (this.from === 'ocpc') {
              this.$router.push({
                name: 'ocpc'
              })
            } else {
              this.$router.go(-1)
            }
          }
        })
        .params({
          inquiryid: this.inquiryId
        })
        .fetch()
    },
    async handleArchive () {
      const chain = await this.getArchiveTypes()
      chain.onSuccess(raw => {
        this.$router.push({
          query: {
            ...this.$route.query,
            tab: 'archive'
          }
        })
      })
    },
    async handleAssocToXiaoman () {
      if (this.confirmLoading) return

      this.confirmLoading = true
      let chain = await this.inquirySyncxiaoman({
        inquiryid: this.inquiryId
      })
      chain
        .onSuccess(res => {
          this.permissionInfo.is_synced_xiaoman = 1
          this.permissionInfo.is_show_xiaoman = 0
          eventBus.$emit('getFollowupList')
          this.confirmLoading = false
        }).onNetSuccess(res => {
          this.confirmLoading = false
        })
    },
    handleAction () {
      const {
        is_show_del: isShowDel,
        is_show_apply: isShowApply,
        is_show_historys: isShowHistory,
        is_show_archive: isShowArchive,
        is_show_xiaoman: isShowXiaoman
      } = this.permissionInfo || {}
      let data = []
      if (isShowDel) {
        data.push({
          content: '<span class="fs-danger">' + this.$t('message["981"]') + '</span>',
          class: 'del-btn'
        })
      }
      if (isShowHistory) {
        data.push({
          content: this.$t('message["48"]'),
          class: 'history-btn'
        })
      }
      if (isShowXiaoman) {
        data.push({
          content: '同步至小满',
          class: 'sync-xiaoman-btn'
        })
      }
      if (isShowApply) {
        data.push({
          content: this.$t('message["1044"]'),
          class: 'apply-btn'
        })
      }
      if (isShowArchive) {
        data.push({
          content: this.$t('message["417"]'),
          class: 'archive-btn'
        })
      }
      data.concat({
        content: this.$t('message["896"]'),
        class: 'cancel-btn'
      })
      this.$createActionSheet({
        data,
        onSelect: (item, index) => {
          if (item.class === 'apply-btn') {
            this.handleApply()
          } else if (item.class === 'del-btn') {
            this.handleDelete()
          } else if (item.class === 'cancel-btn') {

          } else if (item.class === 'history-btn') {
            this.$router.push({
              query: {
                ...this.$route.query,
                tab: 'changeHistory'
              }
            })
          } else if (item.class === 'archive-btn') {
            this.handleArchive()
          } else if (item.class === 'sync-xiaoman-btn') {
            this.handleAssocToXiaoman()
          }
        }
      }).show()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.assoc-xiaoman {
  display: flex;
  align-items: center;
  height: 16px;
  line-height: 16px;
  margin-left: 4px;
  padding: 0 8px;
  font-size: 12px;
  font-weight: 400;
  color:#B3B3B3;
  border-radius: 10px;
  border: 1px solid #B3B3B3;
}
.spin-fixed-center.ant-spin {
  position: fixed;
  top: 50%;
  left: 50%;
  margin: -5px 0 0 -5px;
}
.filter-set > i.iconfont {
  font-size: 20px;
}
.no_data {
  margin-top: 40px;
  .logo {
    font-size: 40px;
  }
  p {
    text-align: center;
    height: 24px;
    font-size: 15px;
    font-weight: 400;
    color: rgba(179, 179, 179, 1);
    line-height: 24px;
    margin-bottom: 8px;
  }
  .text {
    margin: 20px auto;
  }
}
</style>
<style lang="scss">
.cube-action-sheet-space {
  width: 200%;
  -webkit-transform: scale(0.5);
  transform: scale(0.5);
  transform-origin: left;
  height: 1px;
  background-color: #dbdbdb;
}
.cube-action-sheet-cancel span,
.cube-action-sheet-item,
.cube-action-sheet-title ::v-deep {
  line-height: 24px;
  padding: 16px;
  font-size: 16px;
  &.border-bottom-1px:after {
    // border-color: #dbdbdb;
    width: 0 !important;
  }
}
.cube-action-sheet-cancel span {
  background-color: #fafafa;
}
</style>
